export const isCypressTest = !!(window as any).Cypress;
